var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block" } },
    [
      _c("div", { staticClass: "colum" }, [
        _c(
          "span",
          {
            staticClass: "com-normal-btn",
            on: {
              click: function($event) {
                return _vm.certificateFn("certificate")
              }
            }
          },
          [
            _c(
              "el-badge",
              {
                staticClass: "color-success",
                attrs: { "is-dot": _vm.rowData.hasCert == 1 }
              },
              [_vm._v("证书/出证")]
            )
          ],
          1
        ),
        _vm.requestType
          ? _c(
              "span",
              {
                staticClass: "com-normal-btn",
                on: {
                  click: function($event) {
                    return _vm.applicationArbitrationFn("certificate")
                  }
                }
              },
              [
                _c("el-badge", { staticClass: "color-success" }, [
                  _vm._v("申请仲裁")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.evidenceFn && !_vm.requestType && !_vm.isInDingTalk
          ? _c(
              "span",
              {
                staticClass: "com-normal-btn",
                attrs: { id: "tag-copy", "data-clipboard-text": _vm.vpresId },
                on: {
                  click: function($event) {
                    return _vm.storeCertificateFn("copy")
                  }
                }
              },
              [
                _c(
                  "el-badge",
                  { staticClass: "color-success", attrs: { "is-dot": false } },
                  [_vm._v("存证查询")]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            "modal-append-to-body": false,
            visible: _vm.sSDialogVisible,
            title: "请选择主体身份",
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.sSDialogVisible = $event
            }
          }
        },
        [
          _vm.sSDialogArr && _vm.sSDialogArr.length > 0
            ? _c(
                "div",
                { staticStyle: { padding: "10px 20px" } },
                [
                  _vm._l(_vm.sSDialogArr, function(item, index) {
                    return [
                      _c(
                        "div",
                        { key: index },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: index },
                              model: {
                                value: _vm.choosedCert,
                                callback: function($$v) {
                                  _vm.choosedCert = $$v
                                },
                                expression: "choosedCert"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(item.signatoryFullName || item.idenName)
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.sSDialogVisible = false
                    }
                  }
                },
                [_vm._v("\n          取消\n        ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    id: "tag-copy1",
                    "data-clipboard-text": _vm.vpresId,
                    size: "small",
                    type: "danger"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSelectCret(_vm.sSDialogArr[_vm.choosedCert])
                    }
                  }
                },
                [_vm._v("\n          确定\n        ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fa3a8bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa3a8bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/existing-evidence.vue
// module id = VirL
// module chunks = 23 24 27 29 31 41 42 43 47